import { ref, onBeforeUnmount, onMounted, watch } from 'vue'
import { WidgetMQ, WidgetMQEvents } from '../WidgetMQ/WidgetMQ'
import { setupTheme } from '../style/theme'

export default function useReactors(theme, size, { shouldReset = true, id = '' } = {}, widgetRef = null, height, themeConfig, version = 'current') {
  const activeTheme = ref(theme)
  const activeSize = ref(size)
  const activeHeightType = ref(height)
  const reorderedTabs = ref([])

  const unwatchThemeChange = watch(
    () => theme.value,
    newTheme => {
      activeTheme.value = newTheme
    }
  )

  const unwatchSizeChange = watch(
    () => size.value,
    newSize => {
      activeSize.value = newSize
    }
  )

  const unwatchHeightChange = watch(
    () => height?.value,
    newHeight => {
      activeHeightType.value = newHeight
    }
  )

  const setupReactors = () => {
    setupTheme(theme, widgetRef, themeConfig, version)

    /* setup state to be from prosp by default */
    activeTheme.value = theme
    activeSize.value = size
    activeHeightType.value = height

    WidgetMQ.subscribe(
      WidgetMQEvents.WIDGET_THEME,
      _theme => {
        activeTheme.value = _theme
        setupTheme(_theme, widgetRef, themeConfig, version)
      },
      id
    )

    WidgetMQ.subscribe(
      WidgetMQEvents.WIDGET_HEIGHT,
      _height => {
        activeHeightType.value = _height
      },
      id
    )

    WidgetMQ.subscribe(
      WidgetMQEvents.WIDGET_SIZE,
      _size => {
        activeSize.value = _size
      },
      id
    )

    WidgetMQ.subscribe(
      WidgetMQEvents.TABS_REORDER,
      newReorderedTabs => {
        reorderedTabs.value = newReorderedTabs
      },
      id
    )
  }

  const resetReactors = () => {
    WidgetMQ.close()
  }

  onMounted(() => {
    setupReactors()
  })

  onBeforeUnmount(() => {
    WidgetMQ.unsubscribe(WidgetMQEvents.WIDGET_THEME, id)
    WidgetMQ.unsubscribe(WidgetMQEvents.WIDGET_SIZE, id)
    WidgetMQ.unsubscribe(WidgetMQEvents.WIDGET_HEIGHT, id)
    WidgetMQ.unsubscribe(WidgetMQEvents.TABS_REORDER, id)

    if (shouldReset) {
      resetReactors()
      unwatchThemeChange()
      unwatchSizeChange()
      unwatchHeightChange()
    }
  })
  return { activeTheme, activeSize, activeHeightType, reorderedTabs }
}
